// Cockpit workflow statuses are reference data served per module (the module's backend strategy
// selects the status type). Keyed by (moduleName, clientId).
export const workflowStatusQueryKeys = {
  all: ["cockpitWorkflowStatuses"] as const,
  list: (clientId: string | undefined, moduleName: string) =>
    [...workflowStatusQueryKeys.all, moduleName, clientId] as const,
};
